import { storageService } from 'js/services/storage.service';
import { type AnyAction, type MiddlewareAPI, type Dispatch } from 'redux';

export const user = (api: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
    if (action.type.startsWith('USER:')) {
        const { hasBeenLoggedIn, hideBalance: stateHideBalance = false } = api.getState().user || {};
        const hideBalance = action.type === 'USER:BALANCE:TOGGLE' ? action.payload : stateHideBalance;

        storageService.session.setItem('user', { hasBeenLoggedIn, hideBalance });
    }

    return next(action);
};
